<form [formGroup]="form">
  <ng-container *ngFor="let setting of formSettings; let i = index">
      <t4-text-field class="col-xs-12 col-md-{{setting.Columns}}" (valueChange)="modelChange(setting.FieldId, $event)" *ngIf="setting.Visible"
                     [form]="form" [settings]="setting" [value]="setting.Value" (keydown.enter)="handleEnterKey($event)">
      </t4-text-field>
  </ng-container>
</form>
